import { useState, useEffect } from "react";
import { Navbar, Container } from "react-bootstrap";
import Lubtrack from "../../img/Lubtrack.svg";
import BrasilBand from "../../img/brasil.png";
import EUABand from "../../img/estados-unidos.png";
import EspanhaBand from "../../img/espanha.png";
import "./sidebar-stylesheet.css";
import { Link } from "react-router-dom";
import ModalVersao from "../../components/modalVersion";
import ModalLogout from "../../components/modalLogout";
import { useTranslation } from "react-i18next";
import IconToSolve from "../../components/icon";
import { useToken } from "../../scripts/tokenContext";

function CustomNavbar() {
  const { t, i18n } = useTranslation();
  const { permissions } = useToken();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const hasAuditLogPermission = (requestedPermissions) => {
    if (!permissions || !Array.isArray(permissions)) return false;
    return requestedPermissions.every((slug) =>
      permissions.some((p) => p.slug === slug),
    );
  };

  useEffect(() => {
    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang) {
      setCurrentLang(storedLang);
    }
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
    setCurrentLang(lang);
  };

  const [showModalVersion, setShowModalVersion] = useState(false);
  const handleShowModalVersion = () => setShowModalVersion(true);
  const handleCloseModalVersion = () => setShowModalVersion(false);

  const [showModalLogout, setShowModalLogout] = useState(false);
  const handleShowModalLogout = () => setShowModalLogout(true);
  const handleCloseModalLogout = () => setShowModalLogout(false);

  const [userInitials, setUserInitials] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [showLangMenu, setShowLangMenu] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.user?.name;
    if (userName) {
      const [firstName, ...rest] = userName.trim().split(" ");
      const lastName = rest.length ? rest[rest.length - 1] : "";
      setUserInitials(
        lastName
          ? `${firstName[0]}${lastName[0]}`.toUpperCase()
          : firstName[0].toUpperCase(),
      );
    }
  }, []);

  return (
    <>
      <Navbar className="menu-top">
        <Container className="menu">
          <Link to="/home/eventos">
            <img
              src={Lubtrack}
              alt={"Lubtrack"}
              className={"img-sidebar"}
              width="100%"
              height="100%"
            />
          </Link>
          <div className="d-inline-flex align-items-center">
            <div
              className="user-menu-container"
              onMouseEnter={() => setShowMenu(true)}
              onMouseLeave={() => setShowMenu(false)}
            >
              <button
                title={t("Página de perfil")}
                className="user-initials btn-table img-user"
              >
                {userInitials}
              </button>

              {showMenu && (
                <div className="user-menu">
                  <Link to="/perfil" className="user-menu-item ">
                    {t("Perfil")}
                  </Link>

                  <div
                    className="lang-menu-container"
                    onMouseEnter={() => setShowLangMenu(true)}
                    onMouseLeave={() => setShowLangMenu(false)}
                  >
                    <button className="user-menu-item">{t("Idioma")}</button>

                    {showLangMenu && (
                      <div className="lang-menu">
                        <button
                          onClick={() => changeLanguage("pt-BR")}
                          style={{
                            fontSize: "14px",
                            fontWeight:
                              currentLang === "pt-BR" ? "bold" : "normal",
                          }}
                        >
                          <img
                            src={BrasilBand}
                            alt="Português"
                            style={{ marginRight: "8px", width: "20px" }}
                          />
                          {t("Português")}
                        </button>
                        <button
                          onClick={() => changeLanguage("en")}
                          style={{
                            fontSize: "14px",
                            fontWeight:
                              currentLang === "en" ? "bold" : "normal",
                          }}
                        >
                          <img
                            src={EUABand}
                            alt="English"
                            style={{ marginRight: "8px", width: "20px" }}
                          />
                          {t("Inglês")}
                        </button>
                        <button
                          onClick={() => changeLanguage("es")}
                          style={{
                            fontSize: "14px",
                            fontWeight:
                              currentLang === "es" ? "bold" : "normal",
                          }}
                        >
                          <img
                            src={EspanhaBand}
                            alt="Español"
                            style={{ marginRight: "8px", width: "20px" }}
                          />
                          {t("Espanhol")}
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    className="user-menu-item"
                    style={{ color: "red" }}
                    onClick={handleShowModalLogout}
                  >
                    {t("Sair")}
                  </button>
                </div>
              )}
            </div>

            <button
              className="btn-table d-flex "
              onClick={handleShowModalVersion}
            >
              <IconToSolve iconName={"Interrogacao"} width={42} height={42} />
            </button>
            {hasAuditLogPermission(["front_audit_logs", "read_audit_logs"]) && (
              <Link
                title={t("Página de logs")}
                className="btn-table d-flex"
                to={"/logs"}
              >
                <IconToSolve iconName={"Info"} width={42} height={42} />
              </Link>
            )}
          </div>
        </Container>
      </Navbar>

      <ModalVersao show={showModalVersion} onHide={handleCloseModalVersion} />
      <ModalLogout show={showModalLogout} onHide={handleCloseModalLogout} />
    </>
  );
}

export default CustomNavbar;
